import { Fragment } from 'react'

import { TextContent } from 'pages/promo-page/model.ts'

import { getCleanHTML } from 'shared/lib/getCleanHTML.ts'
import { ImageLazy } from 'shared/ui/image-lazy'

import s from './styles.module.scss'

interface Props {
  data: TextContent
}

export const TextCard = ({ data }: Props) => {
  return (
    <Fragment>
      <div
        className={s.text}
        dangerouslySetInnerHTML={{
          __html: getCleanHTML(data.text || ''),
        }}
      />

      {data.image && (
        <ImageLazy
          src={data.image}
          alt={'promo image'}
        />
      )}
    </Fragment>
  )
}
